/*
 * File Created: Wednesday, 7th December 2022 10:55:21 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2022 Addble Solutions Private Limited. All Rights Reserved.
 */
import Home from "../pages/Home";
import PageNotFound from "../pages/PageNotFound";
import { Route, Routes } from "react-router-dom";
import React from "react";
import Layout from "./Layout/Layout";
import Order from "../pages/Order";
import About from "../pages/About";
import ViewProduct from "../pages/ViewProduct";

function App(): JSX.Element {
  return (
    <React.Fragment>
      <Routes>
          <Route path="/" element={<Home />} />
          <Route element={<Layout />}>
            <Route path="/order" element={<Order />} />
            <Route path="/about" element={<About />} />
            <Route path="/view/:productID" element={<ViewProduct />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </React.Fragment>
  );
};

export default App;
